import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;
export const http = axios.create({ baseURL: API, withCredentials: true });

export const coverSrc = (u) => (!u ? "" : u.startsWith("/api") ? `${BACKEND}${u}` : u);

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(", ");
  return e?.message || "Something went wrong";
};

export const STORE_LABELS = {
  amazon: "Amazon", kobo: "Kobo", apple: "Apple Books",
  bn: "Barnes & Noble", bookshop: "Bookshop.org", website: "Author's site",
};

export async function streamGenerate(bookId, target, body, onDelta) {
  const res = await fetch(`${API}/books/${bookId}/generate/${target}`, {
    method: "POST", credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body || {}),
  });
  if (!res.ok) {
    let d;
    try { d = (await res.json()).detail; } catch (e) { d = null; }
    throw new Error(d || "Generation failed");
  }
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  let book = null;
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    let i;
    while ((i = buf.indexOf("\n\n")) >= 0) {
      const line = buf.slice(0, i);
      buf = buf.slice(i + 2);
      if (!line.startsWith("data: ")) continue;
      const ev = JSON.parse(line.slice(6));
      if (ev.delta) onDelta(ev.delta);
      if (ev.error) throw new Error(ev.error);
      if (ev.done) book = ev.book;
    }
  }
  if (!book) throw new Error("Generation stopped early, please try again");
  return book;
}

export async function downloadReadersCsv(bookId) {
  const res = await http.get("/readers.csv", { params: bookId ? { book_id: bookId } : {}, responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = "readers.csv";
  a.click();
  URL.revokeObjectURL(url);
}

export const copyText = async (t) => navigator.clipboard.writeText(t);
